import React, { useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, Loader2, Mail, ArrowLeft } from "lucide-react";
import { api, formatError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSuccess(
        data?.message ||
          "Se este e-mail estiver cadastrado, enviaremos as instruções para redefinir sua senha."
      );
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4 py-10">
      <div className="w-full max-w-md">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="mb-3 grid h-14 w-14 place-items-center rounded-2xl bg-emerald-500 text-white">
            <GraduationCap className="h-8 w-8" />
          </span>
          <h1 className="text-3xl font-extrabold text-white">
            Apoia<span className="text-emerald-400">Concursos</span>
          </h1>
          <p className="mt-1 text-sm text-slate-400">Recuperação de senha</p>
        </div>

        <div className="rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-2xl">
          <div className="mb-5">
            <h2 className="text-xl font-extrabold text-white">Esqueceu sua senha?</h2>
            <p className="mt-2 text-sm leading-6 text-slate-400">
              Informe o e-mail da sua conta. Enviaremos um link para criar uma nova senha.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="mb-1 block text-xs font-semibold text-slate-300">
                E-mail
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoComplete="email"
                  placeholder="voce@email.com"
                  className="w-full rounded-lg border border-slate-700 bg-slate-800 py-2.5 pl-10 pr-3 text-sm text-white placeholder-slate-500 outline-none focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/30"
                />
              </div>
            </div>

            {error && (
              <p className="rounded-lg bg-red-500/10 px-3 py-2 text-sm font-medium text-red-400">
                {error}
              </p>
            )}

            {success && (
              <p className="rounded-lg border border-emerald-500/20 bg-emerald-500/10 px-3 py-3 text-sm leading-5 text-emerald-300">
                {success}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-500 py-3 text-sm font-bold text-white hover:bg-emerald-600 disabled:opacity-70"
            >
              {loading && <Loader2 className="h-4 w-4 animate-spin" />}
              Enviar link de recuperação
            </button>
          </form>

          <Link
            to="/login"
            className="mt-5 flex items-center justify-center gap-2 text-sm font-semibold text-slate-400 hover:text-emerald-400"
          >
            <ArrowLeft className="h-4 w-4" />
            Voltar para entrar
          </Link>
        </div>
      </div>
    </div>
  );
}
